import EventEmitter from "./EventEmitter"

export default class Tamanos extends EventEmitter {
    constructor() {
        super()
        this.anchoModal = 0
        this.ancho = window.innerWidth - this.anchoModal
        this.alto = window.innerHeight
        this.pixelRatio = Math.min(window.devicePixelRatio, 2)
        this.posicionTerreno = {
            /*x: 4.6,
            y: -0.01,
            z: -4.6*/
            x: -0.2, 
            y: -0.03, 
            z: -0.3
        }
        this.escalaProyecto = {
            /*x: 0.0475,
            y: 0.0475,
            z: 0.0475*/
            x: 0.05,
            y: 0.05,
            z: 0.05
        }
        this.posicionProyecto = {
            /*x: 0.8,
            y: 0.1,
            z: -2.28*/
            x: 1.9,
            y: -0.01,
            z: 2.38
        }
        this.posicionCamara = {
            x: -0.2,
            y: 20,
            z: 0.2
        }
        

        //Redimensionar
        window.addEventListener('resize', () => {
            this.ancho = window.innerWidth
            this.alto = window.innerHeight
            this.pixelRatio = Math.min(window.devicePixelRatio, 2)
            this.trigger('redimensionar')
        })
    }
}